import { render, staticRenderFns } from "./HotelTable.vue?vue&type=template&id=2f0b8dea"
import script from "./HotelTable.vue?vue&type=script&lang=js"
export * from "./HotelTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports